<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} компонента </v-toolbar>
      <ref-component-card :component="localComponent" :mode="'editor'" @onCompUpdate="doCompUpdate"/>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="doClose"
        >Отмена</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="saveDisabled"
          @click="doSave"
        >{{btnText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import RefComponentCard from '@/components/modules/references/cards/refComponentCard'

export default {
  name: 'refAddComponentDialog',
  components: { RefComponentCard },
  props: ['component', 'value'],
  data () {
    return {
      localComponent: null,
      compName: '',
      compCode: ''
    }
  },
  watch: {
    component (val) {
      if (val) {
        // eslint-disable-next-line no-undef
        this.localComponent = structuredClone(this.component)
      } else {
        this.localComponent = {}
      }
    }
  },
  computed: {
    saveDisabled: {
      get: function () {
        if (!this.localComponent) return true
        const noName = !this.localComponent.COMP_NAME
        const noCode = !this.localComponent.COMP_CODE
        return noName || noCode || !this.dataChanged
      }
    },
    btnText: {
      get () {
        return this.component ? 'Сохранить' : 'Создать'
      }
    },
    hdrText: {
      get () {
        return this.localComponent ? this.dataNew ? 'Добавление' : 'Редактирование' : 'Добавление'
      }
    },
    dataChanged: {
      get () {
        if (this.dataNew) return true
        return this.component.COMP_NAME !== this.localComponent.COMP_NAME || this.component.COMP_CODE !== this.localComponent.COMP_CODE
      }
    },
    dataNew: {
      get: function () {
        console.log('Requested for dataNew. Initial component is ', this.component, '. Local component is ', this.localComponent)
        return !this.localComponent.COMP_ID
      }
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.localComponent.COMP_ID ? 'update' : 'add'
      const processorPath = action === 'update' ? '/api/org/references/updComponent.php' : '/api/org/references/addComponent.php'
      const payload = { ...this.localComponent }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('compAdded', [resp.data.data])
            } else {
              self.$emit('compUpdate', [resp.data.data])
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка добавления компонента: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка добавления компонента: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doCompUpdate (data) {
      console.log('refAddComponentDialog:: doCompUpdate method called ', data)
      this.localComponent = { ...this.localComponent, ...data }
      console.log('refAddComponentDialog:: doCompUpdate current data is ', this.localComponent)
    }
  },
  mounted () {
    console.log('refAddComponentDialog mounted with component ', this.component)
  }
}
</script>

<style scoped>

</style>
